'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const MarketBorrowersError = () => {
  return <ErrorDataUnavailable minHeight="480px" />
}

export default memo(MarketBorrowersError)
